import { render, staticRenderFns } from "./PortfolioCompanyItem.vue?vue&type=template&id=43c68246&scoped=true&"
import script from "./PortfolioCompanyItem.vue?vue&type=script&lang=ts&"
export * from "./PortfolioCompanyItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c68246",
  null
  
)

export default component.exports